import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import { fetchFaq, createFaq, updateFaq, deleteFaq } from '../utils/faqApi';
import './AdminGallery.css';

export default function AdminFaq() {
    const [faqItems, setFaqItems] = useState([]);
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const loadFaqs = async () => {
        const data = await fetchFaq();
        setFaqItems(data || []);
    };

    useEffect(() => {
        loadFaqs();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setMessage({ type: '', text: editingId ? 'Updating FAQ...' : 'Saving FAQ...' });
            
            if (editingId) {
                await updateFaq(editingId, { question, answer });
                setMessage({ type: 'success', text: 'Success! FAQ updated.' });
                setEditingId(null);
            } else {
                await createFaq({ question, answer });
                setMessage({ type: 'success', text: 'Success! FAQ added.' });
            }
            
            setQuestion('');
            setAnswer('');
            loadFaqs();
        } catch (error) {
            setMessage({ type: 'danger', text: `Failed: ${error.message}` });
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (item) => {
        setEditingId(item.id);
        setQuestion(item.question || '');
        setAnswer(item.answer || '');
    }

    const cancelEdit = () => {
        setEditingId(null);
        setQuestion('');
        setAnswer('');
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this FAQ?")) return;
        try {
            await deleteFaq(id);
            setMessage({ type: 'success', text: 'FAQ deleted!' });
            loadFaqs();
        } catch(error) {
            setMessage({ type: 'danger', text: 'Failed to delete.' });
        }
    }

    return (
        <div className="admin-gallery-container pt-5 pb-5">
            <div className="container">
                <AdminNavbar />

                {message.text && (
                    <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
                        {message.text}
                        <button type="button" className="close" onClick={() => setMessage({type: '', text: ''})} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <div className="admin-card upload-card">
                            <h4>{editingId ? 'Edit FAQ' : 'Add New FAQ'}</h4>
                            <p className="text-muted" style={{fontSize: '0.9rem'}}>{editingId ? 'Update this question.' : 'Add a new question to the public FAQ section.'}</p>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label>Question</label>
                                    <input type="text" className="form-control" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="e.g. Do you offer transportation?" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Answer</label>
                                    <textarea className="form-control" rows="4" value={answer} onChange={(e) => setAnswer(e.target.value)} placeholder="Provide the answer..." required />
                                </div>
                                
                                <button type="submit" className="upload-btn w-100 mt-4" disabled={loading}>
                                    {loading ? 'Saving...' : editingId ? 'Update FAQ' : 'Add FAQ'}
                                </button>
                                {editingId && (
                                    <button type="button" onClick={cancelEdit} className="btn btn-secondary w-100 mt-2 font-weight-bold" disabled={loading}>
                                        Cancel Edit
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="admin-card">
                            <h4>Current FAQs</h4>
                            <div className="row admin-grid mt-4">
                                {faqItems.map((item) => (
                                    <div className="col-md-6 mb-4" key={item.id}>
                                        <div className="card shadow-sm border-0 h-100">
                                            <div className="card-body">
                                                <h5 className="font-weight-bold text-primary mb-3">
                                                  <i className="fa fa-question-circle mr-2"></i>
                                                  {item.question}
                                                </h5>
                                                <p className="m-0 text-muted" style={{fontSize: '0.9rem'}}>{item.answer}</p>
                                                
                                                <div className="d-flex justify-content-between mt-4" style={{gap: '10px'}}>
                                                    <button onClick={() => handleEdit(item)} className="btn btn-sm btn-outline-primary flex-fill font-weight-bold">
                                                        ✏️ Edit
                                                    </button>
                                                    <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-outline-danger flex-fill font-weight-bold">
                                                        🗑️ Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
